import { useState, useEffect } from "react";
import api from '../api';
import * as XLSX from "xlsx";
import '../styles/alunosTable.scss';

const AlunosTable = () => {
    const [alunos, setAlunos] = useState([]);
    const [filteredAlunos, setFilteredAlunos] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const alunosPorPagina = 10;

    useEffect(() => {
        const fetchAlunos = async () => {
            try {
                const response = await api.get('/alunos');
                setAlunos(response.data);
                setFilteredAlunos(response.data);
            } catch (error) {
                console.error("Erro ao buscar alunos:", error);
            }
        };

        fetchAlunos();
    }, []);

    useEffect(() => {
        const results = alunos.filter(aluno =>
            aluno.NOME.toLowerCase().includes(searchTerm.toLowerCase()) ||
            (aluno['DATA INGRESSO'] && aluno['DATA INGRESSO'].toLowerCase().includes(searchTerm.toLowerCase())) ||
            aluno.RA.toLowerCase().includes(searchTerm.toLowerCase())
        );
        setFilteredAlunos(results);
        setCurrentPage(1); // Resetar a página para 1 ao filtrar
    }, [searchTerm, alunos]);


    const downloadExcel = () => {
        const worksheet = XLSX.utils.json_to_sheet(filteredAlunos);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Alunos');


        // Formata a data e hora atual
        const now = new Date();
        const formattedDate = now.toLocaleString('pt-BR', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            hour12: false
        }).replace(/\//g, '-').replace(',', ''); // Substitui / por - e remove a vírgula

        const fileName = `Alunos—${formattedDate}.xlsx`; // Define o nome do arquivo

        // Faz o download do arquivo Excel
        XLSX.writeFile(workbook, fileName);
    };

    const indexOfLastAluno = currentPage * alunosPorPagina;
    const indexOfFirstAluno = indexOfLastAluno - alunosPorPagina;
    const currentAlunos = filteredAlunos.slice(indexOfFirstAluno, indexOfLastAluno);
    const totalPages = Math.ceil(filteredAlunos.length / alunosPorPagina);

    // Lógica para exibir os números das páginas
    const getPaginationButtons = () => {
        const buttons = [];
        const maxButtonsToShow = 5;

        // Adiciona o primeiro botão
        buttons.push(1);

        // Adiciona "..." se houver uma grande diferença entre a página atual e a próxima
        if (currentPage > 3) {
            buttons.push("...");
        }

        // Adiciona as páginas em torno da página atual
        for (let i = Math.max(2, currentPage - 1); i <= Math.min(totalPages - 1, currentPage + 1); i++) {
            buttons.push(i);
        }

        // Adiciona "..." se houver uma grande diferença entre a página atual e a última
        if (currentPage < totalPages - 2) {
            buttons.push("...");
        }

        // Adiciona a última página
        if (totalPages > 1) {
            buttons.push(totalPages);
        }

        return buttons;
    };

    return (
        <div>
            <h1>Alunos Por Polo</h1>
            <input
                type="text"
                placeholder="Filtrar por Aluno, RA ou Data de Ingresso"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
            />
            <button onClick={downloadExcel}>Download Excel</button>
            <table>
                <thead>
                    <tr>
                        <th>POLO</th>
                        <th>RA</th>
                        <th>NOME</th>
                        <th>DATA INGRESSO</th>
                        <th>TIPO CURSO</th>
                        <th>CURSO</th>
                        <th>STATUS CURSO</th>
                        <th>ENDEREÇO COMPLETO</th>
                        <th>EMAIL</th>
                    </tr>
                </thead>
                <tbody>
                    {currentAlunos.map((aluno, index) => (
                        <tr key={index}>
                            <td>{aluno.POLO}</td>
                            <td>{aluno.RA}</td>
                            <td>{aluno.NOME}</td>
                            <td>{aluno['DATA INGRESSO']}</td>
                            <td>{aluno['TIPO CURSO']}</td>
                            <td>{aluno.CURSO}</td>
                            <td>{aluno['STATUS CURSO']}</td>
                            <td>{aluno['ENDEREÇO COMPLETO']}</td>
                            <td>{aluno.EMAIL}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
            <div className="pagination">
                {getPaginationButtons().map((page, index) => (
                    <button key={index} onClick={() => {
                        if (page !== "...") {
                            setCurrentPage(page);
                        }
                    }} disabled={page === "..."}>
                        {page}
                    </button>
                ))}
            </div>
        </div>
    );
};

export default AlunosTable;
